import { render, staticRenderFns } from "./medidas.vue?vue&type=template&id=60ea3494"
import script from "./medidas.vue?vue&type=script&lang=js"
export * from "./medidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports